import React, { useEffect } from 'react';
import { 
    Box, 
    Flex, 
    Text,
    IconButton,
} from '@chakra-ui/react';
import FileUploadWrapper from '../file/UploadWrapper';
import { CustomFileProps } from '../../../types/ui';
import SvgIcon from '../icons/SvgIcon';
import CustomButton from '../buttons/Button';
import { BsTrash } from 'react-icons/bs';

export default function CustomFileUI({ documentType, files, onChange }: CustomFileProps) {
    console.log({ files, onChange });
    
    function onFileChange(files: any) { 
        console.log({ files });
               
        if (files){
            onChange && onChange(files)
        }
    }

    function computeFileCTAText() {
        switch(documentType.key) {
            case 'file':
            case 'folder':
                return `Choose a ${documentType.key}`
            case 'multiple_files':
                return 'Choose mutiple files'
            case 'pdf':
                return 'Choose PDF'
            default:
                return 'Choose a file'
        }
    }

    function computeReplaceFileText() {
        switch(documentType.key) {
            case 'file':
            case 'folder':
                return `Replace ${documentType.key}`
            case 'multiple_files':
                return 'Replace mutiple files'
            case 'pdf':
                return 'Replace PDF'
            default:
                return 'Replace file'
        }
    }

    function computeFileUploads({ isDragActive }: { isDragActive: boolean }): React.ReactNode {
        return (
            <>
                {((Array.isArray(files) && !files.length) || !files) ? (
                    <Flex direction={'column'} justifyContent='center' alignItems='center'>
                        <SvgIcon 
                            type='Upload'
                            viewBox="0 0 36 36" 
                            height='36px'
                            width='36px'
                            color='indigo'
                            styles={{ marginBottom: '1rem' }}
                        />
                        <Text size='xs' fontSize={'xs'} color='gray.500' marginBottom='2'>No files chosen, yet!</Text>
                        <CustomButton 
                            type='button'
                            cta='outline'
                            variant='outline'
                            color='blue.400'
                            colorScheme='blue'
                            size='sm'
                            label={computeFileCTAText()}
                        />
                    </Flex>
                ) : (
                    <Flex direction={'column'} justifyContent='center' alignItems='center'>
                        <Box marginBottom='4'>
                            {Array.isArray(files) ? (
                                files.map(file => (
                                    <Text size='sm' fontSize={'sm'} color='gray.500' marginBottom='2'>{file?.name}</Text>
                                ))
                            ) : (
                                <Text size='sm' fontSize={'sm'} color='gray.500' marginBottom='2'>{files?.name}</Text>
                            )}
                        </Box>
                        <Flex alignItems='center' marginTop='8' justifyContent='center' width={'100%'}>
                            <CustomButton 
                                type='button'
                                cta='outline'
                                variant='outline'
                                color='blue.400'
                                colorScheme='blue'
                                size='sm'
                                label={computeReplaceFileText()}
                            />
                            <IconButton
                                variant='ghost'
                                colorScheme='red'
                                aria-label='Delete file'
                                fontSize='20px'
                                icon={<BsTrash />}
                            />
                        </Flex>
                    </Flex>  
                )}
            </>
        )
    }

    useEffect(() => {
        const key = documentType?.key;
        if (key) {
            onChange && onChange([])
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentType?.key])
    
    return (
        <Box>
            <FileUploadWrapper 
                onUpload={(file) => { onFileChange(file)}} 
                isMultiple={documentType?.key === 'multiple_files' ? true : false}
                accept={documentType?.accept}
            >
                {computeFileUploads({ isDragActive: true })}
            </FileUploadWrapper>
        </Box>
    )
}